export function formatET(dateLike = new Date(), opts = {}) {
  return new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    hour: 'numeric',
    minute: '2-digit',
    weekday: 'short',
    ...opts,
  }).format(new Date(dateLike));
}
